(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- Menü (mobil) & Untermenüs ---------- */
  var menuBtn = $('[data-menu-btn]');
  var nav = $('[data-nav]');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  $$('[data-sub-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.has-sub');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.has-sub')) {
      $$('.has-sub.is-open').forEach(function (i) {
        i.classList.remove('is-open');
        var b = $('[data-sub-toggle]', i);
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* ---------- Ankündigungsleiste ---------- */
  var msgs = $$('[data-announce] .announce__msg');
  if (msgs.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var mi = 0;
    setInterval(function () {
      msgs[mi].classList.remove('is-active');
      mi = (mi + 1) % msgs.length;
      msgs[mi].classList.add('is-active');
    }, 4500);
  }

  /* ---------- Suche mit Vorschlägen ---------- */
  var search = $('[data-search]');
  if (search) {
    var sInput = $('[data-search-input]', search);
    var sRes = $('[data-search-results]', search);
    var sTimer = null;
    var sCount = 0;
    var openSearch = function () {
      search.hidden = false;
      document.body.classList.add('no-scroll');
      sInput.focus();
    };
    var closeSearch = function () {
      search.hidden = true;
      document.body.classList.remove('no-scroll');
    };
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) { openSearch(); }
      else if (e.target.closest('[data-search-close]')) { closeSearch(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !search.hidden) closeSearch();
    });
    sInput.addEventListener('input', function () {
      clearTimeout(sTimer);
      var q = sInput.value.trim();
      if (!q) { sRes.innerHTML = ''; return; }
      sTimer = setTimeout(function () {
        var id = ++sCount;
        var url = search.getAttribute('data-url') + '?q=' + encodeURIComponent(q) +
          '&section_id=predictive-search&resources[type]=product&resources[limit]=6';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (id !== sCount) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var res = doc.querySelector('[data-predictive]');
            sRes.innerHTML = res ? res.innerHTML : '';
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ---------- Sortierung & Filter ---------- */
  var sort = $('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
  var fBtn = $('[data-filter-toggle]');
  var fForm = $('[data-filters]');
  if (fBtn && fForm) {
    var stored = null;
    try { stored = window.sessionStorage.getItem('filtersOpen'); } catch (e) {}
    if (stored === '1') { fForm.classList.add('is-open'); fBtn.setAttribute('aria-expanded', 'true'); }
    fBtn.addEventListener('click', function () {
      var open = fForm.classList.toggle('is-open');
      fBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      try { window.sessionStorage.setItem('filtersOpen', open ? '1' : '0'); } catch (e) {}
    });
    var fTimer = null;
    fForm.addEventListener('change', function () {
      clearTimeout(fTimer);
      fTimer = setTimeout(function () { fForm.submit(); }, 400);
    });
  }

  /* ---------- Produktseite ---------- */
  var form = $('[data-product-form]');
  var dataEl = $('[data-variants]');
  if (form && dataEl) {
    var variants = JSON.parse(dataEl.textContent);
    var groups = $$('[data-option]', form);
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add]', form);
    var priceEl = $('[data-price]');
    var saveEl = $('[data-save]');
    var stickyPrice = $('[data-sticky-price]');
    var stickyBtn = $('[data-sticky-add]');
    var stickyBar = $('[data-sticky-atc]');

    if (groups.length) {
      form.addEventListener('change', function () {
        var selected = groups.map(function (g) {
          var c = $('input:checked', g);
          return c ? c.value : null;
        });
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
        if (!match) {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-unavailable');
          if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = addBtn.getAttribute('data-unavailable'); }
          return;
        }
        idInput.value = match.id;
        var label = match.available ? addBtn.getAttribute('data-add-label') : addBtn.getAttribute('data-soldout');
        addBtn.disabled = !match.available;
        addBtn.textContent = label;
        if (stickyBtn) { stickyBtn.disabled = !match.available; stickyBtn.textContent = label; }
        if (priceEl) priceEl.innerHTML = (match.compare ? '<s>' + match.compare + '</s> ' : '') + '<strong>' + match.price + '</strong>';
        if (saveEl) saveEl.textContent = match.save || '';
        if (stickyPrice) stickyPrice.innerHTML = match.price;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      });
    }

    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        stickyBar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(addBtn);
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { addBtn.click(); });
    }
  }

  var sizeDialog = $('[data-size-dialog]');
  if (sizeDialog && sizeDialog.showModal) {
    $$('[data-size-open]').forEach(function (b) { b.addEventListener('click', function () { sizeDialog.showModal(); }); });
    $$('[data-size-close]', sizeDialog).forEach(function (b) { b.addEventListener('click', function () { sizeDialog.close(); }); });
    sizeDialog.addEventListener('click', function (e) { if (e.target === sizeDialog) sizeDialog.close(); });
  }

  /* ---------- Karussells ---------- */
  $$('[data-carousel]').forEach(function (root) {
    var track = $('[data-carousel-track]', root);
    var prev = $('[data-carousel-prev]', root);
    var next = $('[data-carousel-next]', root);
    function by(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.8 }); }
    if (prev) prev.addEventListener('click', function () { by(-1); });
    if (next) next.addEventListener('click', function () { by(1); });
  });

  /* ---------- Produktempfehlungen ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.querySelector('.grid')) {
          el.innerHTML = fresh.innerHTML;
          el.hidden = false;
        }
      })
      .catch(function () {});
  });

  /* ---------- Warenkorb-Seitenleiste ---------- */
  var drawer = $('[data-drawer]');
  if (!drawer) return;
  var panel = $('.drawer__panel', drawer);
  var lastFocus = null;
  var urls = {
    cart: drawer.getAttribute('data-cart-url'),
    add: drawer.getAttribute('data-add-url'),
    change: drawer.getAttribute('data-change-url'),
    root: drawer.getAttribute('data-root')
  };

  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    panel.focus();
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function updateCount() {
    return fetch(urls.cart, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('.count').forEach(function (el) { el.textContent = cart.item_count; });
      });
  }
  function refreshDrawer() {
    return fetch(urls.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = $('[data-drawer-content]', doc);
        var current = $('[data-drawer-content]', drawer);
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .then(updateCount);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
    var qty = e.target.closest('[data-line]');
    if (qty && drawer.contains(qty)) {
      qty.disabled = true;
      fetch(urls.change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(qty.getAttribute('data-line')), quantity: Number(qty.getAttribute('data-quantity')) })
      }).then(refreshDrawer).catch(function () { qty.disabled = false; });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  if (form) {
    var errorEl = $('[data-form-error]', form);
    form.addEventListener('submit', function (e) {
      var btn = e.submitter;
      if (!btn || btn.name !== 'add') return;
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      btn.disabled = true;
      fetch(urls.add, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            if (errorEl) { errorEl.textContent = res.body.description || 'Das Produkt konnte nicht hinzugefügt werden.'; errorEl.hidden = false; }
            return;
          }
          return refreshDrawer().then(openDrawer);
        })
        .catch(function () {
          if (errorEl) { errorEl.textContent = 'Das Produkt konnte nicht hinzugefügt werden. Versuch es noch einmal.'; errorEl.hidden = false; }
        })
        .then(function () { btn.disabled = false; });
    });
  }
})();
